import useGetFollowedTopic from "@hooks/useGetFollowedTopic";
import type { ReactElement } from "react";

/**
 * This component is used to fetch the followed keywords by the user and set them in the store.
 */
const MyBHFollowedKeywords = (): ReactElement => {
  useGetFollowedTopic();

  return <></>;
};

export default MyBHFollowedKeywords;
